<template>
  <div class="dsdiv mt15">
    <div class="htmldiv">
      <div class="est">
        <router-link to="/aedu/professional/index" class="more fr tc9 mt5 mr5">更多+</router-link>
        <span class="tt blue prelative dinline-block prelative pb5 fs20 fbold">专业介绍</span>
      </div>
      <div class="cont pt5 fs0">
        <EduImgItem :controller="'aedu'" v-for="(item,index) in proIntroduction" v-if="index < 4" :key="index" :index="index" :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import EduImgItem from '../../index/edu-img-item.vue'
export default {
  name: "pro-introduction",
  props: [
    'proIntroduction',
  ],
  components:{
    EduImgItem
  }
}
</script>

<style scoped>
  .est{border-bottom: 1px solid #ddd;}
  .est .tt{margin-bottom: -1px;}
  .est .blue{border-bottom: 1px solid #1787e0;}
  .eindex-wrap .dsdiv .cont{padding: 50px 0 40px;}
  .eindex-wrap .dsdiv .sdiv{margin: 0 9px;}
  .eindex-wrap .dsdiv .sdiv:hover{margin-top: -5px;}
  .eindex-wrap .dsdiv .sdiv:nth-child(4n + 1){margin-left: 0;}
  .eindex-wrap .dsdiv .sdiv:nth-child(4n){margin-right: 0;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/index/pro-introduction.vue